import React from 'react';

const ErrorBoundaryFallback = ({ error, resetError, eventId }) => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-slate-100 p-8 text-center">
        <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-5 text-2xl font-bold">
          !
        </div>

        <h2 className="text-2xl font-bold text-slate-800 mb-2">
          Something went wrong
        </h2>

        <p className="text-slate-600 text-sm mb-4 leading-relaxed">
          We encountered an unexpected error. Our engineering team has been notified automatically.
        </p>

        {eventId && (
          <div className="mb-6 inline-block bg-slate-100 px-3 py-1.5 rounded-lg text-xs font-mono text-slate-600 border border-slate-200">
            Event ID: <span className="text-slate-800 font-semibold">{eventId}</span>
          </div>
        )}

        {import.meta.env.DEV && error && (
          <div className="mb-6 p-3 bg-red-50 rounded-lg text-left overflow-auto max-h-40 border border-red-100">
            <p className="text-xs font-mono text-red-700 whitespace-pre-wrap break-words">
              {error.message || String(error)}
            </p>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={() => {
              if (resetError) resetError();
              window.location.reload();
            }}
            className="w-full sm:w-auto px-6 py-2.5 bg-[#3869B3] hover:bg-[#2e5594] text-white text-sm font-medium rounded-xl transition duration-200 shadow-sm shadow-[#3869B3]/25 cursor-pointer"
          >
            Reload Page
          </button>
          <button
            type="button"
            onClick={() => {
              window.location.href = '/';
            }}
            className="w-full sm:w-auto px-6 py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-medium rounded-xl transition duration-200 cursor-pointer"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
